import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonState,
  ButtonType,
  InputSize,
  InputState,
  IWorkExperience,
} from '../../../assets/types/dtoTypes';
import {InputComponent} from "../../shared/input/input.component";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {AppInputAreaComponent} from "../../shared/text-areas/app-input-area.component";
import {ButtonComponent} from "../../shared/button/button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-work-experience-manager',
  templateUrl: './work-experience-manager.component.html',
  styleUrls: ['./work-experience-manager.component.scss'],
  standalone: true,
  imports: [
    InputComponent,
    FormsModule,
    TranslateModule,
    AppInputAreaComponent,
    ButtonComponent,
    NgIf
  ]
})
export class WorkExperienceManagerComponent {
  dialogRef = inject<MatDialogRef<WorkExperienceManagerComponent>>(MatDialogRef);
  data = inject<IWorkExperience>(MAT_DIALOG_DATA);

  workExperience: IWorkExperience;

  isInvalid: boolean = true;

  validationErrors = {
    requiredFields: false,
    startDateFuture: false,
    invalidRange: false,
  };

  constructor() {
    const data = this.data;

    this.workExperience = { ...data };
    this.validateForm();
  }

  updateDescription( $event: string ) {
    this.workExperience.jobDescription = $event;
  }

  validateForm(): void {
    const { jobTitle, organization, location, startDate, jobDescription } = this.workExperience;
    const endDate = this.workExperience.completionDate;
    const now = new Date();

    const start = new Date( startDate );
    const end = endDate ? new Date( endDate ) : null;

    const allFieldsFilled = jobTitle && organization && location && startDate && jobDescription;
    const isStartValid = start.getTime() < now.getTime();
    const isRangeValid = !end || start.getTime() < end.getTime();

    this.validationErrors.requiredFields = !allFieldsFilled;
    this.validationErrors.startDateFuture = allFieldsFilled && !isStartValid;
    this.validationErrors.invalidRange = allFieldsFilled && !isRangeValid;


    this.isInvalid = !( allFieldsFilled && isStartValid && isRangeValid );
  }

  onInputChange() {
    this.validateForm();
  }

  save() {
    if ( this.validateDates() ) {
      this.dialogRef.close( this.workExperience );
    }
  }

  validateDates(): boolean {
    const start = new Date( this.workExperience.startDate );
    const end = this.workExperience.completionDate
      ? new Date( this.workExperience.completionDate )
      : null;

    const now = new Date();

    const isStartValid = start.getTime() < now.getTime();

    const isRangeValid = !end || start.getTime() < end.getTime();

    this.isInvalid = !( isStartValid && isRangeValid );

    return !this.isInvalid;
  }


  cancel() {
    this.dialogRef.close();
  }

  protected readonly ButtonType = ButtonType;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly InputState = InputState;

  protected readonly InputSize = InputSize;
}
